// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Link } from '../../../link';
import isPathSelected from '../../../../utils/is-path-selected';
export const LinksComponent = ({ link, className = '', currentPath, navigate, }) => {
    return (React.createElement(Link, { href: link.path, className: `${className} ${isPathSelected(link.path, currentPath) ? 'selected' : ''}`, callback: () => navigate(link.path) }, link.title));
};
//# sourceMappingURL=component.js.map